<template>
  <ElForm class="keyword-planner-choose-keywords-form" @submit="submitForm">
    <ElFormItem class="keyword-planner-choose-keywords-form__search-form-item">
      <TagInput
        v-model="items"
        :max="MAX_ITEMS"
        :placeholder="$t('ADVERTISEMENT.KEYWORDPLANNER.SEARCH_PLACEHOLDER')"
        class="keyword-planner-choose-keywords-form__search-input"
      />
      <InputHelper el-icon="el-icon-question">
        {{ $t('ADVERTISEMENT.KEYWORDPLANNER.SEARCH_HELP') }}
      </InputHelper>
    </ElFormItem>
    <ElFormItem>
      <ElButton
        :loading="isLoading"
        :disabled="!items.length"
        type="primary"
        @click="submitForm"
      >
        {{ $t('SEARCH') }}
      </ElButton>
    </ElFormItem>
  </ElForm>
</template>

<script>
import InputHelper from '@@/common/InputHelper';
import TagInput from '@@/common/TagInput';
import { MAX_ITEMS } from '../common/constants';

export default {
  name: 'KeywordPlannerChooseKeywordsForm',
  components: {
    TagInput,
    InputHelper,
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    MAX_ITEMS() {
      return MAX_ITEMS;
    },
  },
  methods: {
    submitForm() {
      this.$emit('submit', this.items);
    },
  },
};
</script>

<style lang="scss">
.keyword-planner-choose-keywords-form {
  display: flex;
  align-items: flex-start;
  justify-content: center;

  @include breakpoint(medium down) {
    flex-direction: column;
  }

  &__search {
    &-input {
      width: 100%;
    }

    &-form-item {
      margin-right: $global-margin;
      @include rtl() {
        margin-left: $global-margin;
        margin-right: 0;
      }

      @include breakpoint(medium down) {
        width: 100%;
        margin-bottom: $global-margin;
      }
      flex-grow: 1;
      flex-basis: 0;
    }
  }
}
</style>
